import * as types from '../actions/types'

const initialState = {
  years: [],
  // перечень годов ещё не запрашивался: до ответа сервера отбор считается
  // неподобранным и поверх таблицы висит индикатор
  yearsLoaded: false,
  weeks: [],
  // учебный год, которому принадлежит перечень недель: пока он не совпал с
  // выбранным в отборе, перечень считается устаревшим и неделя по нему не
  // подставляется
  weeksYearId: null,
  terms: [],
  termsYearId: null,
  lessons: [],
  totalLessons: 0,
  totalHours: 0,
  // неделя, за которую получено расписание: пока она не совпала с выбранной,
  // в состоянии лежит расписание другой недели и показывать его нельзя
  lessonsWeekId: null,
  isLoading: false,
}

export default function teacherSchedule(state = initialState, action) {
  switch (action.type) {
    case types.TEACHER_SCHEDULE_YEARS_FETCHED:
      return { ...state, years: action.payload, yearsLoaded: true }

    case types.TEACHER_SCHEDULE_WEEKS_FETCHED:
      return { ...state, weeks: action.payload.weeks, weeksYearId: action.payload.yearId }

    case types.TEACHER_SCHEDULE_TERMS_FETCHED:
      return { ...state, terms: action.payload.terms, termsYearId: action.payload.yearId }

    case types.TEACHER_SCHEDULE_LESSONS_FETCH_STARTED:
      return { ...state, isLoading: true }

    case types.TEACHER_SCHEDULE_LESSONS_FETCHED:
      return {
        ...state,
        lessons: action.payload.lessons || [],
        totalLessons: action.payload.total_lessons || 0,
        totalHours: action.payload.total_hours || 0,
        lessonsWeekId: action.payload.weekId,
        isLoading: false,
      }

    case types.TEACHER_SCHEDULE_LESSONS_FETCH_FAILED:
      return {
        ...state,
        lessons: [],
        totalLessons: 0,
        totalHours: 0,
        lessonsWeekId: action.payload,
        isLoading: false,
      }

    case types.TEACHER_SCHEDULE_RESET:
      return initialState

    default:
      return state
  }
}
